import gql from 'graphql-tag';

import userFragment from '~/shared/graphql-queries/users/user-fragment';

const disconnectTelegramMutation = gql`
    mutation DisconnectTelegram {
        disconnectTelegram {
            ...UserFragment
        }
    }
    ${userFragment}
`;

export default disconnectTelegramMutation;
